<script setup>
import { useDisplay } from 'vuetify'
import { rotate } from '@/composables/canvasHelper.js'

const props = defineProps({
  includeZoom: { default: false, type: Boolean },
})
const baseRotation = defineModel('baseRotation', { type: Number, default: null })

defineEmits(['click:recenter', 'click:zoomIn', 'click:zoomOut', 'openShareDialog'])

const { mobile } = useDisplay()
</script>

<template>
  <div
    class="position-absolute d-flex align-center ga-2"
    :class="{ 'flex-column': mobile }"
  >
    <v-tooltip
      location="top"
      scroll-strategy="close"
    >
      <template #activator="{ props: tooltipProps }">
        <v-btn
          v-bind="tooltipProps"
          class="rounded-circle"
          variant="elevated"
          icon="mdi-share-variant"
          @click="$emit('openShareDialog')"
        />
      </template>
      <span>{{ $t('general_interface.buttons.share') }}</span>
    </v-tooltip>

    <v-tooltip
      location="top"
      scroll-strategy="close"
    >
      <template #activator="{ props: tooltipProps }">
        <v-btn
          v-bind="tooltipProps"
          class="rounded-circle"
          variant="elevated"
          icon="mdi-rotate-left"
          @click="() => (baseRotation = rotate(baseRotation, 'left'))"
        />
      </template>
      <span>{{ $t('canvas.navigation.rotate_left') }}</span>
    </v-tooltip>

    <v-tooltip
      location="top"
      scroll-strategy="close"
    >
      <template #activator="{ props: tooltipProps }">
        <v-btn
          v-if="includeZoom"
          v-bind="tooltipProps"
          class="rounded-circle"
          variant="elevated"
          icon="mdi-magnify-plus"
          @click="$emit('click:zoomIn')"
        />
      </template>
      <span>{{ $t('canvas.navigation.zoom_in') }}</span>
    </v-tooltip>

    <v-tooltip
      location="top"
      scroll-strategy="close"
    >
      <template #activator="{ props: tooltipProps }">
        <v-btn
          v-if="props.includeZoom"
          v-bind="tooltipProps"
          class="rounded-circle"
          variant="elevated"
          icon="mdi-magnify-minus"
          @click="$emit('click:zoomOut')"
        />
      </template>
      <span>{{ $t('canvas.navigation.zoom_out') }}</span>
    </v-tooltip>

    <v-tooltip
      location="top"
      scroll-strategy="close"
    >
      <template #activator="{ props: tooltipProps }">
        <v-btn
          v-bind="tooltipProps"
          class="rounded-circle"
          variant="elevated"
          icon="mdi-target"
          @click="$emit('click:recenter')"
        />
      </template>
      <span>{{ $t('canvas.navigation.reset_view') }}</span>
    </v-tooltip>
  </div>
</template>

<style scoped></style>
